import { colors } from '../foundation';

type Props = {
  color?: (typeof colors.red)[100] | typeof colors.primary.white;
};

const TiktokIcon = ({ color = colors.primary.white }: Props) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_462_192192)">
      <path
        d="M10.3031 9.98483V13.8492C9.81628 13.7205 9.30673 13.7027 8.81208 13.7971C8.31743 13.8916 7.8503 14.0959 7.44515 14.395C7.03999 14.6941 6.70715 15.0803 6.47119 15.5252C6.23522 15.9701 6.10214 16.4623 6.08176 16.9655C6.08176 18.6938 7.14452 20.1923 9.33226 20.1923C11.7323 20.1923 12.5828 18.5015 12.5828 16.9212V1.6062H16.4078C17.0576 5.65133 19.08 6.59033 21.789 7.02345V10.8991C21.789 10.8991 18.5745 10.6711 16.5161 9.1182V16.7746C16.515 20.2392 14.4611 24.1062 9.36414 24.1062C4.63277 24.1062 2.21289 20.0975 2.21289 16.7386C2.21289 13.3797 5.39139 9.26258 10.3031 9.98483Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_462_192192">
        <rect width="24" height="24" fill={color} transform="translate(0 0.856201)" />
      </clipPath>
    </defs>
  </svg>
);

export default TiktokIcon;
